import { render, staticRenderFns } from "./InstitutionalOffice.vue?vue&type=template&id=4701d31c"
import script from "./InstitutionalOffice.vue?vue&type=script&lang=js"
export * from "./InstitutionalOffice.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalOffice.vue?vue&type=style&index=0&id=4701d31c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports